import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  background: none;\n  text-decoration: none;\n  font-size: 12px;\n  height: 19px;\n  line-height: 19px;\n  font-weight: 600;\n  color: ", ";\n  padding: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n  font-weight: normal;\n  text-align: center;\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  font-size: 14px;\n  line-height: 15px;\n  color: ", ";\n  text-align: center;\n  font-weight: 600;\n  margin: 0 auto;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  align-items: center;\n  width: 60%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  background: none;\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 15px;\n  color: ", ";\n  font-weight: 600;\n  min-width: 20px;\n  padding: 0;\n  text-align: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin: 0;\n  padding: 40px 20px 20px;\n  background: #ffffff;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MetaTags from 'react-meta-tags';
import { AcornsIcon } from '@acorns/icons';
import { WEBVIEW_ACTION_STRIP, WEBVIEW_ACTION_STRIP_BACK, WEBVIEW_ACTION_STRIP_CANCEL } from '../utils/testing/TestIDs';
import styled from '../utils/styling/styled-components';
var WebViewActionStripContainer = styled.div(_templateObject());
var WebViewActionStripAction = styled.button(_templateObject2(), function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.align || 'center';
});
var TitleContainer = styled.div(_templateObject3());
var WebViewActionStripTitle = styled.div(_templateObject4(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.link && !props.action && 'padding-left: 45px;';
}, function (props) {
  return props.link && props.action && 'padding-left: 30px;';
}, function (props) {
  return !props.link && !props.action && 'padding: 0;';
});
var WebViewActionStripSubtitle = styled.div(_templateObject5(), function (props) {
  return props.theme.colors.stone;
});
var BackArrow = styled.div(_templateObject6());
var WebViewCancelLink = styled.button(_templateObject7(), function (props) {
  return props.theme.colors.stone;
});

var WebViewMetaTags = function WebViewMetaTags() {
  return /*#__PURE__*/React.createElement(MetaTags, null, /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width"
  }));
};

export var WebViewActionStrip = function WebViewActionStrip(_ref) {
  var align = _ref.align,
      action = _ref.action,
      link = _ref.link,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WebViewMetaTags, null), /*#__PURE__*/React.createElement(WebViewActionStripContainer, {
    "data-testid": WEBVIEW_ACTION_STRIP
  }, action && /*#__PURE__*/React.createElement(WebViewActionStripAction, {
    "data-testid": WEBVIEW_ACTION_STRIP_BACK,
    onClick: action.onClick,
    align: align
  }, /*#__PURE__*/React.createElement(BackArrow, null, action.shouldShowCloseIcon ? /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CloseXIcon,
    width: '16px'
  }) : /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.ArrowLeft,
    width: '16px'
  }))), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(WebViewActionStripTitle, {
    action: action,
    link: link
  }, title), /*#__PURE__*/React.createElement(WebViewActionStripSubtitle, null, subtitle)), link && /*#__PURE__*/React.createElement(WebViewCancelLink, {
    "data-testid": WEBVIEW_ACTION_STRIP_CANCEL,
    onClick: link.onClick
  }, link.text)));
};